import angular from 'angular';

(function() {
    'use strict';

    angular.module('app.core').run(Redirection);

    Redirection.$inject = ['$rootScope', '$state', 'logger', 'PrincipalSvc'];

    function Redirection($rootScope, $state, logger, PrincipalSvc) {
        $rootScope.$on('$stateChangeStart', stateChangeStart);
        $rootScope.$on('$stateChangeError', stateChangeError);

        function stateChangeStart(event, toState /*, toParams, fromState, fromParams*/) {
            if (
                toState.data &&
                toState.data.principalCreation &&
                !toState.data.firstStep &&
                PrincipalSvc.shouldRedirectCreate()
            ) {
                event.preventDefault();
                $state.go('app.principal.create.detail');
            }
        }

        //
        // Uniquement pour le debuggage car pas d'erreur dans la console quand le
        // resolve d'une route ne fonctionne pas
        //
        function stateChangeError(event, toState, toParams, fromState, fromParams, error) {
            logger.log('stateChangeError:event', event);
            logger.log('stateChangeError:toState', toState, 'toParams', toParams);
            logger.log('stateChangeError:fromState', fromState, 'fromParams', fromParams);
            logger.log('stateChangeError:error', error);
            logger.error('error.generic');
        }
    }
})();
